import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    q: 'How do I receive Wrestling Coach Ready after purchasing?',
    a: "You'll receive digital access to the materials after completing your purchase. No physical shipping. No waiting.",
  },
  {
    q: 'What level of coaching experience do I need?',
    a: 'Wrestling Coach Ready is designed to support coaches working with developing, intermediate and advanced athletes. The sessions provide clear structures, progressions and adaptations that allow you to select the appropriate level for your wrestlers.',
  },
  {
    q: 'Can wrestling coaches from different countries use the system?',
    a: 'Yes. The material focuses on wrestling coaching, athlete development, practice structure, technique progression and competition preparation rather than one specific school or club program.',
  },
  {
    q: 'Can I edit or customize the files?',
    a: 'The materials are provided as finished PDF resources. They are not Word documents and are not editable files. You can choose the sessions, progressions and activities that best fit your athletes.',
  },
  {
    q: 'What athlete levels does the system cover?',
    a: 'The system begins with foundational movement and develops through takedowns, top wrestling, bottom wrestling, chain wrestling, match intelligence and competition preparation. It can therefore support athletes across multiple stages of development.',
  },
  {
    q: 'What format are the materials?',
    a: 'All materials are delivered digitally in PDF format.',
  },
  {
    q: 'Are videos included?',
    a: 'No. Wrestling Coach Ready is a complete PDF-based coaching system. Videos are not included.',
  },
  {
    q: 'Is this just a drill collection?',
    a: 'No. The system includes drills, but its main purpose is to organize them into complete progressions and ready-to-coach practices. You receive full sessions, coaching cues, situational work, competition scenarios, decision-making systems, practice planning and athlete-development resources.',
  },
  {
    q: "What if the material doesn't work for me?",
    a: 'Your purchase is protected by our 7-day money-back guarantee.',
  },
]
